import { useCallback, useState } from "react";
import { auth, db } from "../lib/firebase";
import { doc, getDoc } from "firebase/firestore";

export type NdaDoc = {
  type: 'NDA';
  dealId: string;
  receivingUid: string;
  disclosingCompanyName?: string;
  purpose: string;
  confidentialInfoDefinition: string;
  termMonths: number;
  nonDisclosurePeriod: number;
  applicableLaw: string;
  enforcement: string;
  signatures: { receiving?: string; disclosing?: string };
  status: 'draft' | 'signed';
  createdAt?: any;
  updatedAt?: any;
};

export function useNdaGate(appId: string) {
  const [loading, setLoading] = useState(false);

  const hasSignedNdaForDeal = useCallback(async (dealId: string): Promise<boolean> => {
    const u = auth.currentUser;
    if (!u || !dealId) return false;
    setLoading(true);
    try {
      const ndaRef = doc(db, 'signedNDAs', `${dealId}_${u.uid}`);
      const snap = await getDoc(ndaRef);
      return snap.exists();
    } catch {
      return false;
    } finally {
      setLoading(false);
    }
  }, []);

  return { loading, hasSignedNdaForDeal } as const;
}